import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading">🌸</span>
              <span className="text-xl font-heading font-bold text-background-50">樱花漫画</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              免费漫画全集在线阅读平台<br />
              下拉式阅读，追更不等待<br />
              好看的漫画尽在樱花漫画
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              <a href="/" className="hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
              <a href="/category/all" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/xuan-huan" className="text-sm text-background-400 hover:text-primary-400 transition-colors">玄幻漫画</Link></li>
              <li><Link to="/category/wu-xia" className="text-sm text-background-400 hover:text-primary-400 transition-colors">武侠漫画</Link></li>
              <li><Link to="/category/lian-ai" className="text-sm text-background-400 hover:text-primary-400 transition-colors">恋爱漫画</Link></li>
              <li><Link to="/category/re-xue" className="text-sm text-background-400 hover:text-primary-400 transition-colors">热血漫画</Link></li>
              <li><Link to="/category/xuan-yi" className="text-sm text-background-400 hover:text-primary-400 transition-colors">悬疑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i>
                <span>support@sakuramanga.example.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-wechat-line"></i>
                <span>sakuramanga_official</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-qq-line"></i>
                <span>1234567890</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020-2026 樱花漫画 SakuraManga. 本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors">首页</Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-primary-400 transition-colors">关于我们</Link>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}